/**
 *
 * List of Brightcove video IDs from NikeTeam folder in Brightcove
 *    https://studio.brightcove.com/products/videocloud/media/folders/63754b563bcef31890ab72f3
 *
 */
export const VID_ID_STRONGER_THAN_ONE = "6315688510112";
